import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../../theme'

const width = Dimensions.get('window').width

const styles = StyleSheet.create({
    containerGeneral: {
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginHorizontal: 0,
        marginBottom: 10,
        maxWidth: '100%',
        alignContent: 'center',
    },
    subContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: 12,
    },
    container: {
        flex: 1,
        flexDirection: 'column',
        width: '100%',
        backgroundColor: 'white',
    },
    containerItem: {
        flex: 1,
        flexDirection: 'row',
        paddingRight: 10,
    },
    containerRow: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    image: {
        width: 80,
        height: 80,
    },
    imagePreview: {
        width: 80,
        height: 80,
        borderRadius: 5,
    },
    fileName: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'normal',
        textAlign: 'left',
        paddingHorizontal: 8,
    },
    containerMiniButton: {
        flexDirection: 'row',
        borderWidth: 2,
        borderRadius: 5,
        borderColor: theme.colors.colorPrimary,
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 0,
        paddingVertical: 4,
        paddingHorizontal: 8,
    },
    containerMiniButtonDelete: {
        flexDirection: 'row',
        //width: 72,
        borderWidth: 2,
        borderRadius: 5,
        borderColor: theme.colors.error,
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 8,
        paddingVertical: 4,
        paddingHorizontal: 8,
    },
    textMiniButton: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
    },
    textMiniButtonDelete: {
        fontSize: 12,
        fontWeight: 'bold',
        color: theme.colors.error,
    },
    containerData: {
        flex: 1,
        alignItems: 'flex-start',
        //justifyContent: 'space-between',
    },
    title: {
        fontSize: 15,
        color: theme.colors.textPrimary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingTop: 0,
        paddingBottom: 15,
        paddingHorizontal: 0,
        //marginBottom: 'auto',
    },
    description: {
        fontSize: 18,
        color: theme.colors.textSecondary,
        fontWeight: 'bold',
        textAlign: 'left',
        paddingBottom: 5,
        paddingHorizontal: 0,
        //marginTop: 'auto',
    },
    dividerHorizontalLine: {
        width: '100%',
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        marginVertical: 10,
    },
    buttonContainer: {
        flexDirection: 'column',
        width: '100%',
        paddingVertical: 5,
    },
    borderButton: {
        borderWidth: 2,
        borderColor: theme.colors.colorPrimary,
        paddingVertical: 8,
        paddingHorizontal: 50,
        marginHorizontal: 15,
        marginBottom: 15,
        borderRadius: 10,
    },
    borderButtonText: {
        color: theme.colors.colorPrimary,
        fontWeight: 'bold',
        fontSize: 15,
        textAlign: 'center',
    },
    floatingButton: {
        flexDirection: 'row',
        backgroundColor: theme.colors.filtersBackground,
        borderRadius: 5,
        justifyContent: 'center',
        alignItems: 'center',
        marginHorizontal: 15,
        marginBottom: 20,
        padding: 10,
    },
    floatingButtonText: {
        color: theme.colors.colorPrimary,
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'center',
        marginRight: 5,
    },
    iconButtonContainer: {
        flexDirection: 'row',
        borderColor: theme.colors.lightGray,
        borderWidth: 0.5,
        borderRadius: 15,
        marginHorizontal: 0,
        marginBottom: 0,
        alignItems: 'center',
        justifyContent: 'space-evenly',
        paddingVertical: 0,
    },
    iconButton: {
        alignItems: 'center',
        padding: 10,
    },
    iconButtonText: {
        color: theme.colors.colorPrimary,
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
        paddingTop: 6,
    },
    containerTakePhoto: {
        width: width / 1.85,
        height: width / 1.85,
        borderRadius: 100,
        borderWidth: 2.0,
        borderColor: theme.colors.colorPrimary,
        alignSelf: 'center',
        justifyContent: 'center',
    },
    containerEditPhoto: {
        width: 60,
        height: 60,
        borderRadius: 50,
        backgroundColor: theme.colors.colorPrimary,
        justifyContent: 'center',
        position: 'absolute',
        top: 0,
        right: 0,
        zIndex: 1,
    },
    previewPhoto: {
        width: width / 2,
        height: width / 2,
        borderRadius: 100,
        alignSelf: 'center',
    },
    takePhoto: {
        width: width / 2,
        height: width / 2,
        borderRadius: 100,
        backgroundColor: theme.colors.colorPrimary,
        alignSelf: 'center',
        justifyContent: 'center',
    },
    takePhotoText: {
        color: theme.colors.textPrimary,
        fontSize: 15,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    takePhotoAsset: {
        width: 70,
        height: 70,
    },
    takePhotoButton: {
        width: width / 2,
        borderWidth: 1.2,
        borderRadius: 20,
        borderColor: theme.colors.colorPrimary,
        alignItems: 'center',
        alignSelf: 'center',
        paddingVertical: 4,
        paddingHorizontal: 8,
    },
    seeReferenceText: {
        color: theme.colors.colorPrimary,
        fontSize: 15,
        fontWeight: '600',
        textAlign: 'center',
    },
    status: {
        fontSize: 16,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    statusDescriptionText: {
        color: theme.colors.textSecondary,
        fontSize: 15,
        fontWeight: '600',
        textAlign: 'center',
    },
    dividerHorizontalLine: {
        borderBottomWidth: 0.5,
        borderBottomColor: theme.colors.lightGray,
        width: '100%',
        marginVertical: 10,
    },
    dividerVerticalLine: {
        borderLeftWidth: 1,
        borderLeftColor: theme.colors.lightGray,
        height: '100%',
    },
    marginHorizontal: {
        marginHorizontal: 12,
    },
    marginLeft: {
        marginLeft: 4,
    },
    marginLeftBis: {
        marginLeft: 8,
    },

    alignCenter: {
        alignSelf: 'center',
    },
    spacer: { height: 4 },
    spacer1: { height: 12 },
    spacer2: { height: 6 },
})

export default styles
